import { autoChooseClassnames, getId } from '@common/utils/brandDiffsUtils';
import Accordion from '@ui/accordion/Accordion';
import AccordionItem from '@ui/accordion/AccordionItem';
import useBreakpoint from '@utils/useBreakpoint';
import FocusTrap from 'focus-trap-react';
import React, { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
const StoreLocatorRegions = (props) => {
    const { t } = useTranslation();
    const { filteredStores, close } = props;
    const dispatch = useDispatch();
    const currentBreakpoint = useBreakpoint();
    const regions = useRef();
    const breakpointToAccordion = getId() === 'MO' ? window.mqObj.sm : window.mqObj.lg;
    const countryStores = useMemo(() => {
        if (filteredStores.length) {
            let arr = {};
            filteredStores.forEach((store) => {
                if (arr[store.countryCode.value]) {
                    arr[store.countryCode.value].count += 1;
                }
                else {
                    arr[store.countryCode.value] = {
                        count: 1,
                        countryName: store.countryCode.displayValue,
                        region: store.region,
                    };
                }
            });
            console.info('countries: ', arr);
            return arr;
        }
    }, [filteredStores]);
    const getDetails = async (results) => {
        const request = {
            placeId: results[0].place_id,
            fields: ['address_components'],
        };
        await new Promise((resolve) => {
            props.placeService.getDetails(request, (result, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK) {
                    const newArr = [];
                    // console.log('result ', result);
                    results.forEach((el) => {
                        newArr.push(Object.assign(Object.assign({}, el), { address_components: result.address_components }));
                    });
                    // props.searchedCountry(result.address_components[0]?.short_name);
                    props.onRegionClick(newArr);
                }
                resolve(status);
            });
        });
    };
    const getCountryBounds = async (countryName) => {
        const request = {
            query: countryName,
            fields: ['name', 'geometry', 'formatted_address', 'place_id'],
        };
        await new Promise((resolve) => {
            props.placeService.findPlaceFromQuery(request, (results, status) => {
                if (status === google.maps.places.PlacesServiceStatus.OK) {
                    getDetails(results);
                    close(true);
                }
                resolve(status);
            });
        });
    };
    const getRegionColumn = (region, noTitle) => {
        let currentRegions = [];
        switch (region) {
            case 'Europe':
                currentRegions = ['EU'];
                break;
            case 'Americas':
                currentRegions = ['NA', 'SA'];
                break;
            case 'Asia & Oceania':
                currentRegions = ['AS', 'OC'];
                break;
            default:
                break;
        }
        const regionalCountries = Object.values(countryStores).filter((el) => currentRegions.includes(el.region.value));
        if (regionalCountries.length > 0) {
            return (React.createElement("div", { className: "region-col" },
                !noTitle && React.createElement("h3", null, region),
                React.createElement("ul", { className: "nolist" }, regionalCountries.map((country, i) => (React.createElement("li", { key: i },
                    React.createElement("button", { type: "button", onClick: () => getCountryBounds(country.countryName) },
                        country.countryName,
                        " (",
                        country.count,
                        React.createElement("span", { className: "visually-hidden" }, t(country.count > 1 ? 'storelocator.nboutiques' : 'storelocator.nboutique', { 0: filteredStores.length })),
                        ")")))))));
        }
    };
    return (React.createElement(FocusTrap, { focusTrapOptions: {
            onDeactivate: close,
            allowOutsideClick: (e) => {
                if (!regions.current.contains(e.target)) {
                    const isAnchor = e.target;
                    if (isAnchor === null || isAnchor === void 0 ? void 0 : isAnchor.href) {
                        window.location.href = isAnchor.href;
                    }
                    else {
                        close();
                    }
                }
                return true;
            },
        } },
        React.createElement("div", { role: "dialog", "aria-modal": "true", ref: regions, className: "search-store__regions", id: "allLocationsOptions", "aria-describedby": "allLocationsOptionsTitle" },
            React.createElement("button", { className: autoChooseClassnames({
                    MO: 'icon--close',
                    ST: 'button__close icon--16-close',
                }), type: "button", "aria-label": t('button.close'), onClick: () => {
                    close();
                } }),
            React.createElement("h2", { className: "search-store__regions__title", id: "allLocationsOptionsTitle" }, t('storelocator.allboutiques')),
            currentBreakpoint < breakpointToAccordion ? (React.createElement("div", { className: "wrapper-regions" },
                React.createElement(Accordion, null,
                    React.createElement(AccordionItem, { title: "Europe", accordionId: "region1" }, getRegionColumn('Europe', true)),
                    React.createElement(AccordionItem, { title: "Americas", accordionId: "region2" }, getRegionColumn('Americas', true)),
                    React.createElement(AccordionItem, { title: "Asia & Oceania", accordionId: "region3" }, getRegionColumn('Asia & Oceania', true))))) : (React.createElement("ul", { className: "nolist wrapper-regions" },
                React.createElement("li", null, getRegionColumn('Europe')),
                React.createElement("li", null, getRegionColumn('Americas')),
                React.createElement("li", null, getRegionColumn('Asia & Oceania')))))));
};
export default StoreLocatorRegions;
